// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Report .Details:not(.inline) {
  width: 90%;
  margin: 0 auto;
}
.Report .VirtualTable {
  border: var(--vt-item-border);
  border-width: 1px 0;
}
.Report .VirtualTable .VirtualTable-Cell {
  text-align: center;
}
.Report .VirtualTable .VirtualTable-Row > .VirtualTable-Expand + .VirtualTable-Cell {
  text-align: left;
}
.Report .VirtualTable .VirtualTable-Expanded + .VirtualTable-Row {
  border-top: var(--vt-item-border);
}
.Report .VirtualTable .VirtualTable-Expanded .VirtualTable-Row > .VirtualTable-Expand + .VirtualTable-Cell {
  text-align: center !important;
}
.Report .VirtualTable .VirtualTable-Expanded .VirtualTable-Expanded .VirtualTable-Row > .VirtualTable-Expand + .VirtualTable-Cell {
  text-align: right !important;
}
.Report .VirtualTable *:not(.VirtualTable-Header) .VirtualTable-Row {
  border-top: var(--vt-item-border);
}
.Report .VirtualTable *:not(.VirtualTable-Header) .VirtualTable-Row .VirtualTable-Cell {
  border: var(--vt-item-border);
  border-width: 0 0 0 1px;
}

.clientSummaryReport .VirtualTable .VirtualTable-Expanded .VirtualTable-Row > .VirtualTable-Expand + .VirtualTable-Cell {
  text-align: right !important;
}

.trainingReport .Details:not(.inline) .card-body .row {
  justify-content: center !important;
  gap: 3rem;
}
.trainingReport .Details:not(.inline) .card-body .row > .col:has(.DetailsItem[data-name="AVG TRAINING DURATION"]) {
  padding: 0 1rem;
  border-left: 1px solid var(--bs-primary);
  border-right: 1px solid var(--bs-primary);
}
.trainingReport .Details:not(.inline) .card-body .DetailsItem:hover {
  color: #40ade2;
}
.trainingReport .Details:not(.inline) .card-body .DetailsItem:hover span:last-child {
  color: var(--bs-primary);
}
.trainingReport .Table.ReportTable {
  border: 1px solid #e6e8ec;
  border-radius: 0.75rem;
}
.trainingReport .Table.ReportTable .TableCell.ATTEMPTID {
  display: none;
}
.trainingReport .Table.ReportTable .TableRow.ReportTableRow .TableCell .TableCell-Content {
  text-align: left !important;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader {
  overflow: hidden;
  border-top-left-radius: 0.7rem;
  border-top-right-radius: 0.7rem;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell.SELECT {
  background-color: var(--bs-primary);
  border: 0;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell.SELECT .Button,
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell.SELECT .sv::before {
  color: #fff;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell + .TableCell {
  border-left: 0;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell:last-of-type {
  border-right: 0;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell {
  align-items: center;
}
.trainingReport .Table.ReportTable > table > .Table-Head > .TableRow.ReportTableHeader .TableCell .TableCell-Content {
  white-space: normal;
  overflow: visible;
  overflow-wrap: break-word;
  text-align: left !important;
}
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell,
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell:first-of-type,
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell + .TableCell,
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell:last-of-type {
  border-left: 0;
  border-right: 0;
}
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow:has(+ .TableRow), .trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow:has(+ .TableCollapse) {
  box-shadow: 0 1px 0 0 #e6e8ec;
}
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell.SELECT .Button,
.trainingReport .Table.ReportTable > table > .Table-Body > .TableRow.ReportTableRow .TableCell.SELECT .sv::before {
  color: #000;
}
.trainingReport .Table.ReportTable .TableRow.ReportTableRow.EXPANDED {
  background-color: #f9f6f4;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/DynamicReport/styles.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,cAAA;AAAJ;AAEE;EACE,6BAAA;EACA,mBAAA;AAAJ;AACI;EACE,kBAAA;AACN;AAEM;EACE,gBAAA;AAAR;AAIM;EACE,iCAAA;AAFR;AAKQ;EACE,6BAAA;AAHV;AAQU;EACE,4BAAA;AANZ;AAaM;EACE,iCAAA;AAXR;AAYQ;EACE,6BAAA;EACA,uBAAA;AAVV;;AAoBQ;EACE,4BAAA;AAjBV;;AA0BI;EACE,kCAAA;EACA,SAAA;AAvBN;AAyBM;EACE,eAAA;EACA,wCAAA;EACA,yCAAA;AAvBR;AA2BI;EACE,cAAA;AAzBN;AA2BM;EACE,wBAAA;AAzBR;AA8BE;EACE,yBAAA;EACA,sBAAA;AA5BJ;AA+BI;EACE,aAAA;AA7BN;AAgCI;EACE,2BAAA;AA9BN;AAiCI;EACE,gBAAA;EACA,8BAAA;EACA,+BAAA;AA/BN;AAiCM;EACE,mCAAA;EACA,SAAA;AA/BR;AAiCQ;;EAEE,WAAA;AA/BV;AAkCM;EACE,cAAA;AAhCR;AAkCM;EACE,eAAA;AAhCR;AAkCM;EACE,mBAAA;AAhCR;AAkCM;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;AAhCR;AAqCM;;;;EAIE,cAAA;EACA,eAAA;AAnCR;AAqCM;EAEE,6BAAA;AApCR;AAwCQ;;EAEE,WAAA;AAtCV;AA2CI;EACE,yBAAA;AAzCN","sourcesContent":[".Report {\n  .Details:not(.inline) {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .VirtualTable {\n    border: var(--vt-item-border);\n    border-width: 1px 0;\n    .VirtualTable-Cell {\n      text-align: center;\n    }\n    .VirtualTable-Row {\n      > .VirtualTable-Expand + .VirtualTable-Cell {\n        text-align: left;\n      }\n    }\n    .VirtualTable-Expanded {\n      + .VirtualTable-Row {\n        border-top: var(--vt-item-border);\n      }\n      .VirtualTable-Row {\n        > .VirtualTable-Expand + .VirtualTable-Cell {\n          text-align: center !important;\n        }\n      }\n      .VirtualTable-Expanded {\n        .VirtualTable-Row {\n          > .VirtualTable-Expand + .VirtualTable-Cell {\n            text-align: right !important;\n          }\n        }\n      }\n    }\n\n    *:not(.VirtualTable-Header) {\n      .VirtualTable-Row {\n        border-top: var(--vt-item-border);\n        .VirtualTable-Cell {\n          border: var(--vt-item-border);\n          border-width: 0 0 0 1px;\n        }\n      }\n    }\n  }\n}\n.clientSummaryReport {\n  .VirtualTable {\n    .VirtualTable-Expanded {\n      .VirtualTable-Row {\n        > .VirtualTable-Expand + .VirtualTable-Cell {\n          text-align: right !important;\n        }\n      }\n    }\n  }\n}\n\n.trainingReport {\n  .Details:not(.inline) .card-body {\n    .row {\n      justify-content: center !important; // To override the styles of base headers\n      gap: 3rem;\n\n      > .col:has(.DetailsItem[data-name='AVG TRAINING DURATION']) {\n        padding: 0 1rem;\n        border-left: 1px solid var(--bs-primary);\n        border-right: 1px solid var(--bs-primary);\n      }\n    }\n\n    .DetailsItem:hover {\n      color: #40ade2;\n\n      span:last-child {\n        color: var(--bs-primary);\n      }\n    }\n  }\n\n  .Table.ReportTable {\n    border: 1px solid #e6e8ec;\n    border-radius: 0.75rem;\n\n    // `attemptId` is a data-only column that feeds the Evaluation Summary drill-down - never shown.\n    .TableCell.ATTEMPTID {\n      display: none;\n    }\n\n    .TableRow.ReportTableRow .TableCell .TableCell-Content {\n      text-align: left !important;\n    }\n\n    > table > .Table-Head > .TableRow.ReportTableHeader {\n      overflow: hidden;\n      border-top-left-radius: 0.7rem;\n      border-top-right-radius: 0.7rem;\n\n      .TableCell.SELECT {\n        background-color: var(--bs-primary);\n        border: 0;\n\n        .Button,\n        .sv::before {\n          color: #fff;\n        }\n      }\n      .TableCell + .TableCell {\n        border-left: 0;\n      }\n      .TableCell:last-of-type {\n        border-right: 0;\n      }\n      .TableCell {\n        align-items: center;\n      }\n      .TableCell .TableCell-Content {\n        white-space: normal;\n        overflow: visible;\n        overflow-wrap: break-word;\n        text-align: left !important;\n      }\n    }\n\n    > table > .Table-Body > .TableRow.ReportTableRow {\n      .TableCell,\n      .TableCell:first-of-type,\n      .TableCell + .TableCell,\n      .TableCell:last-of-type {\n        border-left: 0;\n        border-right: 0;\n      }\n      &:has(+ .TableRow),\n      &:has(+ .TableCollapse) {\n        box-shadow: 0 1px 0 0 #e6e8ec;\n      }\n\n      .TableCell.SELECT {\n        .Button,\n        .sv::before {\n          color: #000;\n        }\n      }\n    }\n\n    .TableRow.ReportTableRow.EXPANDED {\n      background-color: #f9f6f4;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
